module.exports = require("./ak.js");